module.exports = __webpack_public_path__ + "static/media/imgInfografia.67898899.jpg";